import { IPlayer } from '../../user/store';

export interface IAdminMembership {
  club: number;
  groups: any[];
  id: number;
  status: string;
  user: IPlayer;
}

export interface IAdminMembershipsStore {
  memberships: IAdminMembership[];
}

export const adminMembershipsStore: IAdminMembershipsStore = {
  memberships: []
};
